// Khoảng thời gian tự động gọi lại API thông báo đơn hẹn giờ (5 phút)
export const RECALL_INTERVAL = 5 * 60 * 1000

// Giá trị filter khởi tạo dùng để trigger gọi API
export const DEFAULT_SCHEDULE_FILTER = {
  reCall: 1,
}

// Đường dẫn điều hướng khi bấm vào thông báo
export const SCHEDULE_ORDER_URL = '/order?status=New&orderType=Schedule'
